import { normalizeKeys } from './propsUtils'

export const isListingType = (listingData, slug) => {
  const listing = normalizeKeys(listingData)
  return listing && listing.listingType && listing.listingType.slug === slug
}

export const isAccommodation = (listing) =>
  isListingType(listing, 'accommodation')

export const isEquipment = (listing) => isListingType(listing, 'equipment')

export const isExperience = (listing) => isListingType(listing, 'experiences')

export const isMotorVehicle = (listing) =>
  isListingType(listing, 'motor-vehicle')

export const hasProperty = (listing, key) =>
  ({}).hasOwnProperty.call(listing, key)

export const amenitiesForListingType = (listingData, listingFieldsData) => {
  if (!listingData || !listingFieldsData) {
    return null
  }

  const listing = normalizeKeys(listingData)
  const listingFields = normalizeKeys(listingFieldsData)

  const listingType = listingFields.listingTypes.find(
    (t) => t.slug === listing.listingType.slug,
  )
  return listingType.amenities
}

export const isOnAirBnb = (listing) => listing && listing.on_airbnb

export const adventureTypeIdToSlug = (adventureTypes, id) => {
  // eslint-disable-next-line eqeqeq
  const type = adventureTypes.find((t) => t.id == id)
  if (type) return type.slug
  return ''
}

export const isListingStatus = (listing, status) =>
  listing && listing.status === status

export const isPublished = (listing) => isListingStatus(listing, 'published')
